import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ViolationService } from '../../violations-sets/violation-service/violation.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import * as _ from 'underscore';

@Component({
  selector: 'app-late-forecast',
  templateUrl: './late-forecast.component.html',
  styleUrls: ['./late-forecast.component.css']
})
export class LateForecastComponent implements OnInit, OnDestroy {
  timeZone;
  user;
  todayDate

  skip = 0;
  isShowAllTrips = false;
  trips = [];
  preDriver = {};
  tripsDrivers = [];
  preSpaceTypes;
  violations;
  driversPickupPoints = [];
  search;
  selectedDrivers = [];
  driverWiseTrips;
  isAdvanceMode = false;
  preCooperates = {};
  preServiceAreas = {};
  preLevelOfServices = {};
  preAssistList = {};

  filteredServiceAreas = [];
  selectedServiceAreas = [];
  serviceAreaList = [];
  drivers = [];
  stationManagerList = [];
  preStaffList = {};
  selectedStationManager = [];
  isRdispatcher = false;

  constructor(
    private assignTripService: AssigTripsService,
    private levelOfServiceService: LevelOfServiceService,
    private voilationService: ViolationService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private corporateService: CorporateService,
    private serviceAreas: ServiceAreasService,
    private assistService: AssistService,
    private staffService: StaffService
  ) { }

  ngOnInit() {
    window.addEventListener("keyup", this.initializeSpecialController);
    this.getUser();
  }

  initializeSpecialController = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isAdvanceMode = !this.isAdvanceMode;
    }
  };

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          // this.todayDate = [
          //   moment.tz(this.timeZone).startOf("day").toISOString(),
          //   moment.tz(this.timeZone).endOf("day").toISOString(),
          // ];
          this.todayDate = moment.tz(this.todayDate, this.timeZone).startOf('day').toISOString();

          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }


          this.apiCalls();
          this.getCorporate();
          this.getServiceAreas();
          this.getLevelOfService();
          // this.getAssist();
          this.getStationManagers();
        }
      });
  }

  apiCalls() {
    const requests = [
      this.getSpaceTypes(),
      this.getViolations(),
      this.getDrivers()
    ];

    forkJoin(requests).subscribe(
      ([spaceTypes, voilations, drivers]) => {
        if (spaceTypes) {
          this.preSpaceTypes = spaceTypes.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (voilations) {
          this.violations = voilations;
        }
        if (drivers) {
          this.preDriver = drivers.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        this.getTrips();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreas() {
    this.serviceAreas.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  // getAssist() {
  //   this.assistService.getAllAssists()
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       if (data) {
  //         this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
  //       }
  //     });
  // }

  getSpaceTypes() {
    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getViolations() {
    return this.voilationService.getViolationData();
  }

  getDrivers() {
    let endPoint = '';

    // if (this.selectedServiceAreas && this.selectedServiceAreas.length) {
    //   endPoint = '?serviceAreas=' + this.selectedServiceAreas.toString();
    // }

    const data = {
      endPoint: endPoint,
      userId: this.user._id
    }
    return this.driverService.getDrivers(data.userId, data.endPoint, true);
  }

  getTrips() {
    const range = [
      this.todayDate = moment.tz(this.todayDate, this.timeZone).startOf('day').toISOString(),
      this.todayDate = moment.tz(this.todayDate, this.timeZone).endOf('day').toISOString()
    ]
    const payload = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'all',
      date: range,
      skip: this.skip,
      showBreak: true,
    };

    this.assignTripService
      .getAssignList(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (this.skip === 0) {
          this.clearTrips();
        }

        if (data) {
          // Prepend new data to existing trips
          this.trips = [...data, ...this.trips];

          if (data.length) {
            this.skip += data.length;
            this.getTrips();
          } else {
            // Reset skip and clear driver collections
            this.skip = 0;
            this.tripsDrivers = [];
            this.drivers = [];
            this.driverWiseTrips = {};
            let serviceAreas = [];

            // Process trips to filter and group by driver
            const assignedTrips = this.trips.filter(trip =>
              trip.driver && !(trip.status === 'cancelled' && !trip.job)
            );

            assignedTrips.forEach(trip => {
              if (trip.serviceArea) {
                serviceAreas.push(trip.serviceArea);
              }
            });

            serviceAreas = _.uniq(serviceAreas).sort();

            if (serviceAreas && serviceAreas.length) {
              this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
            }

            // Group trips by driver ID
            this.driverWiseTrips = assignedTrips.reduce((acc, trip) => {
              const driverId = trip.driver._id;
              if (!acc[driverId]) {
                acc[driverId] = [];
              }
              acc[driverId].push(trip);
              return acc;
            }, {});

            // Collect unique drivers
          const myDrivers = _.uniq(
              assignedTrips.map(trip => this.preDriver[trip.driver._id]).filter(Boolean),
              '_id'
            ).sort((a, b) => a._id.localeCompare(b._id));



            if (this.isRdispatcher) {
              this.tripsDrivers = myDrivers.filter(item => item.stationManager === this.user.sId);
            }

            this.drivers = this.tripsDrivers;
          }
        }

      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  async getDriverTimelines(driverId) {
    let queryString = {
      driver: driverId
    };
    const driverTimelines: any = await this.driverService.getDriverTimelines(queryString).toPromise();
    return driverTimelines;
  }

  async setupDriverPickups(driverTrips) {
    for (const driver of this.tripsDrivers) {
      if (!this.selectedDrivers.includes(driver._id)) {
        continue;
      }
      const driverTimelines = await this.getDriverTimelines(driver._id);
      const sortedTrips = driverTrips[driver._id].sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));

      const params = {
        todayDate: this.todayDate,
        user: this.user,
        selectedDriverId: driver._id,
        drivers: this.tripsDrivers,
        violations: this.violations,
        preSpaceTypes: this.preSpaceTypes,
        selectedTimeLines: driverTimelines,
        driverTrips: sortedTrips,
        selectedTripsDriver: this.preDriver[driver._id],
        isGoogleMiles: false
      }
      const trips = await this.assignTripService.setupTripsByPickup(params);
      this.driversPickupPoints.push(...trips);
      // this.driversPickupPoints.push({
      //   _id: driver._id,
      //   tripsPickupPoints: trips.sort((a,b) => <any>moment(a.eta) - <any>moment(b.eta))
      // });
    }
    this.driversPickupPoints.sort((a,b) => <any>moment(a.eta) - <any>moment(b.eta));
  }

  timeValidation(trip) {
    const params = {
      trip,
      violations: this.violations,
      timeZone: this.timeZone
    }
    return this.assignTripService.timeValidation(params);
  }

  getTripDisplayName(assign, first, last) {
    let textLable = '';
    if (assign.priorityClient && assign.priorityClient.displayName) {
      textLable = assign.priorityClient.displayName.toUpperCase();
      if (assign.isPickup) {
        if (assign.isBreakTrip) {
          textLable += " - Start."
        } else {
          textLable += " - Pickup Appt."
        }
      } else if (assign.isDropOff) {
        if (assign.isBreakTrip) {
          textLable += " - End."
        } else {
          textLable += " - Dropoff Appt."
        }
      }
    } else if (first) {
      textLable = "Pull - Out.";
    } else if (last) {
      textLable = "Shift - End.";
    }

    return textLable;
  }

  meterToMiles(distance) {
    return distance.toFixed(2);
    // return (distance / 1609).toFixed(2);
  }

  getUTCTime(travel) {
    return moment(travel).format("HH:mm:ss")
  }

  getFullUTCTime(travel) {
    return moment(travel).format("MM/DD/YYYY")
  }

  getMarkeBall(assign, isPickup) {

    let icon = isPickup ? 'assets/images/map/origin_circle.png' : 'assets/images/map/destination_circle.png'
    if (assign.jobStatus === 'finished' || assign.jobStatus === 'cancelled') {
      icon = 'assets/images/map/finished_circle.png';
    }

    return icon;
  }

  checkDriverFleetSpacetype(trip, driverId) {
    let isExist = false;
    if (trip.spaceType && driverId && this.preDriver[driverId].fleet && this.preDriver[driverId].fleet.capacities && this.preDriver[driverId].fleet.capacities.length) {
      isExist = this.preDriver[driverId].fleet.capacities.some(capacity => capacity.spaceType === trip.spaceType);
    }
    return isExist;
  }

  clearTrips() {
    this.skip = 0;
    this.trips = [];
    this.driversPickupPoints = [];
    this.driverWiseTrips = undefined;
    this.selectedDrivers = [];
    this.tripsDrivers = [];
  }

  onDateChange(event) {
    this.clearTrips();
    this.todayDate = event.toISOString();
    this.getTrips();
  }

  refresh() {
    this.driversPickupPoints = [];
    if (this.selectedDrivers && this.selectedDrivers.length) {
      this.setupDriverPickups(this.driverWiseTrips);
    }
  }

  onSelectAll() {
    if (this.selectedDrivers.length === this.tripsDrivers.length) {
      this.selectedDrivers = [];
    } else {
      this.selectedDrivers = this.tripsDrivers.map(driver => driver._id);
    }
  }

  onChangeServiceAreas() {
    if (this.selectedServiceAreas && this.selectedServiceAreas.length) {
      this.tripsDrivers = this.drivers.filter(driver => {
          return driver.serviceAreas.find(s => this.selectedServiceAreas.includes(s)) ? true : false;
      });
    } else {
      this.tripsDrivers = this.drivers;
    }
  }

  getStationManagers() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          if (this.isRdispatcher) {
            this.stationManagerList = data.filter(staff => staff._id === this.user.sId );
          } else {
            this.stationManagerList = data.filter(staff => ["mdispatcher","mcallcenter","rdispatcher"].includes(staff.roles));
          }

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  stationManagerWiseDrivers() {
    this.onChangeServiceAreas();
    if (this.selectedStationManager && this.selectedStationManager.length) {
      this.tripsDrivers = this.tripsDrivers
        .filter(driver => driver.stationManager && this.selectedStationManager.includes(driver.stationManager));
    }
  }

  ngOnDestroy() {
  }
}
